import React, { useState } from "react";
import { useEffect } from "react";
import { withTranslation } from "react-i18next";
import { IoAddCircleOutline } from "react-icons/io5";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import EditButton from "../../components/EditButton";
import DeleteButton from "../../components/DeleteButton";
import FillingDataTable from "../../components/FillingDataTable";
import Pagination from "../../components/Pagination";
import Select from "../../components/Select";
import { createItem, deleteItem, getItem } from "../../services/service";
import ModalAddAccessoriesDependSpecification from "../../components/accessories/ModalAddAccessoriesDependSpecification";
import swal from "sweetalert";
import SettingButton from "../../components/SettingButton";
import { Context } from "../../context/DependSearchContext";
import { useContext } from "react";
import DependSearchInput from "../../components/search/DependSearchInput";
import { toast } from "react-toastify";
import TemDataTableInline from "../../components/TemDataTableInline";
import CopyButton from "../../components/CopyButton";
import TableComponent from "../../components/tableComponent/tableComponent";

const headerTable = [
  {
    name: "supplier",
    sort: true,
  },
  {
    name: "article",
    sort: true,
  },
  {
    name: "name",
    sort: true,
  },
  {
    name: "color",
    sort: true,
  },
  {
    name:"action"
  }
];

const bodyContent = [
  "supplierName",
  "article",
  "productName",
  "color",
  "actions",
];

function AccessoriesDependSpecificationLayout({
  accessoriesId,
  setSelectedDependSpecificationId,
  selectedMainSpecificationId,
  setSelectedParameterId,
  setSelectedDependSideLimitId,
  t,
}) {
  const navigate = useNavigate();
  const { token } = useSelector((state) => state.user);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [itemOffset, setItemOffset] = useState(0);
  const [forcePage, setForcePage] = useState(0);
  const [open, setOpen] = useState(false);
  const [sortColumn, setSortColumn] = useState("id");
  const [sortDir, setSortDir] = useState("DESC");
  const [clear, setClear] = useState(false);
  const [data, setData] = useState({
    data: [],
    recordsTotal: 0,
    pageCount: 1,
  });
  const [isEdit, setIsEdit] = useState(false);
  const [dependentSpecificationId, setDependentSpecificationId] =
    useState(null);
  const ctx = useContext(Context);

  const handleClose = () => {
    setOpen(false);
    setIsEdit(false);
    setDependentSpecificationId(null);
  };
  const handleOpen = () => {
    setOpen(true);
    setDependentSpecificationId(null);
  };
  const fetchData = async () => {
    const response = await createItem(
      `${process.env.REACT_APP_HOST_BASE_URL}/v1/accessories/dependent/specification/table`,
      token,
      {
        draw: 1,
        start: itemOffset,
        length: itemsPerPage,
        recordsTotal: 0,
        columns: [],
        order: [{ column: sortColumn, dir: sortDir }],
        search: { value: ctx.state, regex: true },
        filter: { specificationId: selectedMainSpecificationId },
      }
    );
    if (response.success) {
      setClear(false);
      let reviewData = response.data.data.map((item, index) => {
        return {
          id: item.id,
          color: item.textureName,
          article: item?.article,
          productName: item.productName,
          supplierName: item.supplierName,
          selected: false,
          actions: (
            <div className="flex justify-end mt-3 sm:mt-0 sm:ml-4">
              <SettingButton onclick={() => onclickSetting(item.id)} />
              <CopyButton onclick={() => copyHandler(item.id)} />
              <EditButton onclick={() => editHandler(item.id)} />
              <DeleteButton onclick={() => deleteHandler(item.id)} />
            </div>
          ),
        };
      });
      setData({
        data: reviewData,
        recordsTotal: response.data.recordsFiltered,
        pageCount: Math.ceil(
          response.data.recordsFiltered / parseInt(itemsPerPage)
        ),
      });
    } else {
      navigate("/error", {
        state: {
          status: response.status,
          message: response.message ? response.message : null,
        },
      });
    }
  };

  useEffect(() => {
    if (clear) {
      fetchData();
    }
  }, [clear]);

  useEffect(() => {
    if (selectedMainSpecificationId) {
      fetchData();
    } else {
      setData({ data: [], recordsTotal: 0, pageCount: 1 });
    }
  }, [
    selectedMainSpecificationId,
    itemOffset,
    itemsPerPage,
    data.recordsTotal,
    ctx.state,
  ]);

  const handlePageClick = (event) => {
    setForcePage(event.selected);
    const newOffset =
      (event.selected * parseInt(itemsPerPage)) % data.recordsTotal;
    setItemOffset(newOffset);
  };

  const onclickSetting = (item) => {
    if (item?.id > 0) {
      navigate(`/furniture/depend/specification/${item.id}`, {
        state: { item: item },
      });
    }
  };

  const sortFunction = (value) => {
    setSortColumn(value.field ? value.field : "id");
    setSortDir(value.sort === true ? "ASC" : "DESC");
    setClear(true);
  };

  const deleteHandler = async (id) => {
    const responseReceived = await swal({
      title: t(`action.delete_item.title`),
      text: t(`action.delete_item.text`),
      icon: "warning",
      buttons: {
        cancel: true,
        confirm: true,
      },
    });
    if (responseReceived) {
      const response = await deleteItem(
        `${process.env.REACT_APP_HOST_BASE_URL}/v1/accessories/dependent/specification/${id}`,
        token
      );
      if (response.success) {
        fetchData();
        toast.success(t("action.delete_success"), {
          position: "bottom-right",
          autoClose: 3000,
          closeOnClick: true,
          className: "add-success",
        });
      } else {
        navigate("/error", {
          state: {
            status: response.status,
            message: response.message ? response.message : null,
          },
        });
      }
    } else {
      return;
    }
  };

  const copyHandler = async (id) => {
    const responseReceived = await swal({
      title: t(`action.delete_item.title`),
      text: t(`action.delete_item.text`),
      icon: "warning",
      buttons: {
        cancel: true,
        confirm: true,
      },
    });
    if (responseReceived) {
      const response = await getItem(
        `${process.env.REACT_APP_HOST_BASE_URL}/v1/accessories/main/specification/copy/${id}`,
        token
      );
      if (response.success) {
        fetchData();
        toast.success(t("action.delete_success"), {
          position: "bottom-right",
          autoClose: 3000,
          closeOnClick: true,
          className: "add-success",
        });
      } else {
        navigate("/error", {
          state: {
            status: response.status,
            message: response.message ? response.message : null,
          },
        });
      }
    } else {
      return;
    }
  };
  const editHandler = (id) => {
    setIsEdit(true);
    setDependentSpecificationId(id);
    setOpen(true);
  };
  return (
    <>
      <ModalAddAccessoriesDependSpecification
        open={open}
        handleClose={handleClose}
        isEdit={isEdit}
        dependentSpecificationId={dependentSpecificationId}
        accessoriesId={accessoriesId}
        mainSpecificationId={selectedMainSpecificationId}
        fetchDataDepend={fetchData}
      />
      <div className="flex items-center justify-between">
        <h1 className="text-xl font-semibold text-gray-900">
          {t(`table.accessories.accessories_dependent`)}
        </h1>
        <button
          className={`${
            selectedMainSpecificationId
              ? "flex items-center px-3 py-1 text-sm font-medium leading-4 text-white bg-indigo-600 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
              : "cursor-no-drop flex items-center px-3 py-1 text-sm font-medium leading-4 text-white bg-indigo-300 border border-transparent rounded-md shadow-sm "
          }   `}
          onClick={() => setOpen(true)}
          disabled={selectedMainSpecificationId ? false : true}
        >
          {t("action.add")}
          <IoAddCircleOutline className="w-4 h-4 ml-1" />
        </button>
      </div>
      <div className="flex items-center justify-between mt-3">
        <Select setItemsPerPage={setItemsPerPage} itemsPerPage={itemsPerPage} />
        <DependSearchInput />
      </div>
      <TableComponent
        transactions={data?.data && data.data}
        bodyOfTable={bodyContent}
        headerOfTable={headerTable}
        rowHandler={(id) => {
          const updatedData = data.data.map((item) => {
            if (item.id === id) {
              return {
                ...item,
                selected: true,
              };
            } else {
              return {
                ...item,
                selected: false,
              };
            }
          });
          setData((prevState) => {
            return {
              ...prevState,
              data: updatedData,
            };
          });
          setSelectedDependSpecificationId(id);
          setSelectedParameterId(id);
          setSelectedDependSideLimitId(id);
        }}
        // sortFunction={sortFunction}
      />
      <Pagination
        handlePageClick={handlePageClick}
        pageCount={data.pageCount}
        forcePage={forcePage}
      />
    </>
  );
}

export default withTranslation()(AccessoriesDependSpecificationLayout);
